'use client';

import Autoplay from 'embla-carousel-autoplay';
import { useEffect, useState } from 'react';
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from '../ui/carousel';

import Image from '../Image';
import { usePathname } from '@/src/i18n/navigation';
import { Routes } from '@/src/routes/routes';
import { IDestination } from '@/src/app/[locale]/(cms)/CMSComponents/services/types';
import RenderDestination from '@/src/app/[locale]/(cms)/CMSComponents/Components/RenderDestination';

export type CarouselSection = {
  slides: { image: string; Destination?: IDestination }[];
  name?: string | null;
  branchId?: number;
};
function LargeCarousel(props: CarouselSection) {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const pathname = usePathname();

  const isDigitalCard = pathname.includes(Routes.digitalCards);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }
    setCurrent(carouselApi?.selectedScrollSnap() + 1);
    carouselApi.on('select', () => {
      setCurrent(carouselApi.selectedScrollSnap() + 1);
    });
  }, [carouselApi]);

  return (
    <div className="flex h-full w-full flex-col space-y-3">
      <Carousel
        dir="ltr"
        plugins={[Autoplay({ delay: 4000 })]}
        setApi={setCarouselApi}
        className="w-full self-center lg:h-full"
      >
        <CarouselContent className="mx-0 h-full w-full lg:h-full">
          {props.slides?.map((item, index) => (
            <CarouselItem key={index} className="h-full w-full rounded-3xl px-1">
              {item.Destination ? (
                <RenderDestination destination={item.Destination} branchId={props.branchId}>
                  <div className="relative aspect-2/1">
                    <Image
                      fill
                      className="rounded-3xl object-cover object-center"
                      src={item.image}
                      alt={`Image`}
                      local={!!isDigitalCard}
                      sizes="(min-width: 1420px) 1651px, 116.82vw"
                    />
                  </div>
                </RenderDestination>
              ) : (
                <div className="relative aspect-4/5">
                  <Image
                    fill
                    className="rounded-lg object-cover object-center"
                    src={item.image}
                    key={item.image}
                    alt={`Image`}
                    local={isDigitalCard}
                    sizes="calc(100vw - 40px)"
                  />
                </div>
              )}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <ul className="flex items-center justify-center space-x-1 rtl:space-x-reverse">
        {props.slides?.map((_, index) => (
          <li
            onClick={() => {
              carouselApi?.scrollTo(index);
            }}
            key={`slider-page-${index}`}
            aria-label="Scroll to item" // Accessible name
            data-active={index === current - 1 ? 'true' : 'false'}
            className="data-[active=true]:bg-primary h-1 rounded-xl transition-all duration-700 data-[active=false]:w-5 data-[active=false]:bg-[#CFCFCF] data-[active=true]:w-16"
          />
        ))}
      </ul>
    </div>
  );
}

export default LargeCarousel;
